import React from 'react';
import { T, useT } from '@transifex/react';

import { useListPrincipals } from 'src/api/principals/hooks';
import {
  useActivePrincipalId,
  useSwitchPrincipal,
} from 'src/app/Principal.store';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

// Principal picker (REQ-20) for the sidebar user block. Only renders when the
// user is authorized for at least one other principal.
export const PrincipalSwitcher: React.FC = () => {
  const tx = useT();
  const { data } = useListPrincipals();
  const activeId = useActivePrincipalId();
  const switchPrincipal = useSwitchPrincipal();

  if (!data || data.principals.length === 0) return null;

  return (
    <div className="wh-ui flex flex-col gap-4">
      <Label className="text-xs font-medium uppercase leading-none tracking-[0.6px] text-[var(--wh-sidebar-fg-muted)]">
        <T _str="Acting as" />
      </Label>
      <Select
        value={activeId ?? 'self'}
        onValueChange={(v) => switchPrincipal(v)}
      >
        {/* Blend with the sidebar (which is tinted by the tenant
            secondary_color): match the footer buttons' surface/border/fg so the
            trigger doesn't render as a bright white box on a dark sidebar. */}
        <SelectTrigger
          className="w-full rounded-[var(--wh-radius,8px)] border-[var(--wh-sidebar-border)] bg-[var(--wh-sidebar-surface)] px-4 text-[16px] leading-[1.5] text-[var(--wh-sidebar-fg)] shadow-none data-[size=default]:h-12 [&_svg]:!text-[var(--wh-sidebar-fg)]"
          aria-label={tx('Switch account')}
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="self">
            {tx('{name} (you)', { name: data.self.displayName })}
          </SelectItem>
          {data.principals.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.displayName}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
